<template>
  <div class="notification-bar rounded shadowed white" :class="notificationTypeClass">
    <i class="material-icons">{{notificationIcon}}</i>
    <p>{{ notification.message }}</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      timeout: null
    }
  },
  mounted() {
    this.timeout = setTimeout(() => this.remove(this.notification), 5000)
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
  computed: {
    notificationTypeClass() {
      return `-text-${this.notification.type}`
    },
    notificationIcon() {
      if (this.notification.type === 'error') {
        return 'warning'
      } else if (this.notification.type === 'success') {
        return 'check_circle'
      }
      return ''
    }
  },
  methods: mapActions('notification', ['remove'])
}
</script>

<style scoped lang="scss">
.notification-bar {
  margin: 1em 0 1em;
  padding: 15px;
  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }

  p {
    margin: 0
  }
}
</style>
